"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchNotificationsQueryDto = void 0;
const cursor_pagination_1 = require("../cursor-pagination");
class SearchNotificationsQueryDto extends cursor_pagination_1.CursorPaginationOptions {
    notification_id;
    category;
    display_id;
    from;
    media_campaign_id;
    media_id;
    read;
    to;
    subcategory;
    flatten;
}
exports.SearchNotificationsQueryDto = SearchNotificationsQueryDto;
